import { styled } from '@mui/system';
import { Button } from '@mui/material';

export const DeviceFieldContainer = styled('div', {
  shouldForwardProp: prop => !['hasError', 'isAligned'].includes(prop)
})(({ theme, hasError, isAligned }) => ({
  width: '100%',
  padding: 14,
  backgroundColor: '#EEE',
  borderRadius: 8,
  display: 'flex',
  flexDirection: 'column',
  gap: 14,
  margin: isAligned ? `${theme.spacing(1)} auto` : theme.spacing(1, 0),
  position: 'relative',
  border: `2px solid ${hasError ? '#f44336' : 'transparent'}`,
  transition: theme.transitions.create(['border-color']),
  boxSizing: 'border-box',
  ...(hasError && {
    marginBottom: 18
  }),
  '& .MuiChip-label': {
    paddingRight: 4
  }
}));

export const Title = styled('div')(() => ({
  paddingBottom: 6,
  fontWeight: 500
}));

export const TitleDisabled = styled(Title)(() => ({
  color: '#00000042'
}));

export const DevicesChipsContainer = styled('div')(() => ({
  display: 'flex',
  flexWrap: 'wrap',
  gap: 4,
  '& div': {
    backgroundColor: '#FFF',
    borderRadius: 6
  }
}));

export const ButtonsContainer = styled('div')(() => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
  gap: 16
}));

const AddButton = styled(Button)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  textTransform: 'initial',
  borderRadius: 8,
  boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.16), 0px 2px 4px rgba(0, 0, 0, 0.12), 0px 1px 8px rgba(0, 0, 0, 0.1)',
  transition: 'none',
  width: '100%',
  padding: 12,
  backgroundColor: '#FFF',
  '&:hover': {
    backgroundColor: '#FFF'
  },
  '& span': {
    fontSize: theme.spacing(2)
  }
}));

export const AddButtonEnabled = styled(AddButton)(({ theme }) => ({
  border: `2px solid ${theme.palette.secondary.main}`
}));

export const AddButtonDisabled = styled(AddButton)(({ theme }) => ({
  border: `2px solid ${theme.palette.grey[600]}`
}));

export const ModifyButton = styled(Button)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  textTransform: 'initial',
  border: `2px solid ${theme.palette.secondary.main}`,
  borderRadius: 8,
  boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.16), 0px 2px 4px rgba(0, 0, 0, 0.12), 0px 1px 8px rgba(0, 0, 0, 0.1)',
  transition: 'none',
  width: '100%',
  padding: 12,
  backgroundColor: theme.palette.secondary.main,
  color: theme.palette.getContrastText(theme.palette.secondary.main),
  '&:hover': {
    backgroundColor: theme.palette.secondary.main
  },
  '& span': {
    fontSize: theme.spacing(2)
  }
}));

export const ErrorText = styled('span')(() => ({
  color: '#f44336',
  fontSize: '0.75rem',
  marginTop: 4
}));
